export const SYNC_TYPE = {
  IMPORT: 0,
  EXPORT: 1,
  ALL: 2,
}



// WEBPACK FOOTER //
// ./src/constants/SalesforceValues.js